import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { MatTooltipModule } from '@angular/material/tooltip';

import { RtConsoleComponent } from './rt-console.component';

@NgModule({
  declarations: [RtConsoleComponent],
  imports: [
    CommonModule,
    IonicModule,
    MatTooltipModule,
  ],
  exports: [RtConsoleComponent],
})
export class RtConsoleModule {}
